export const awards = [
	{
		id: 1,
		type: 'E-Commerce Web',
		desc: 'A Web Application built with React.js',
		toWeb: "https://lumimi.vercel.app/",
		toGitHub: "https://github.com/samfajobi/Lumimi-Ecommerce-Website"
	},
	{
		id: 2,
		type: 'Social Media App',
		desc: 'A Social Media application',
		toWeb: "https://precise-tracker.vercel.app",
		toGitHub: "https://github.com/samfajobi/precise-tracker-frontend"
	},
	{
		id: 2,
		type: 'Reservation WebApp',
		desc: 'A Reservation Web App built with the MERN stack for making space reservation',
		toWeb: "https://miamibooking.vercel.app/",
		toGitHub: "https://github.com/samfajobi/MiamiReservation-backend"
	},
	{
		id: 4,
		type: 'Business Website',
		desc: 'A Business Website built with React.js for a sales company',
		toWeb: "https://christabossglobal.netlify.app/",
		toGitHub: "https://github.com/samfajobi/ChiristabossWeb"
	},
	{
		id: 5,
		type: 'Weather App',
		desc: 'A Weather  Application built with React.js',
		toWeb: "https://predictweatherapp.netlify.app/",
		toGitHub: "https://github.com/samfajobi/MyWeatherApp"
	},
	{
		id: 6,
		type: 'E-commerce Store',
		desc: 'Web Application built with MERN',
		toWeb: "https://predictweatherapp.netlify.app/",
		toGitHub: "https://github.com/samfajobi/MERN-Fullstack-EcommerceWebApp"
	}
];



